import {
  type DatabaseField,
  DatabaseFieldType,
  type DatabaseValue
} from '@databases/types/database';
import { type ValueChange } from '@databases/utils/database/changesets';

const DATE_ONLY_VALUE_REGEXP = /^\d{4}-\d{2}-\d{2}$/;
const DATE_TIME_SUFFIX_REGEXP = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}.*)$/;

export function getBulkEditDateValueForEntry({
  bulkEditValue,
  existingValue,
  field
}: {
  bulkEditValue: DatabaseValue;
  existingValue: DatabaseValue | undefined;
  field: DatabaseField;
}): { value: DatabaseValue; change: ValueChange | null } {
  if (
    field.type !== DatabaseFieldType.DATE ||
    !field.settings.timeFormat ||
    bulkEditValue.type !== DatabaseFieldType.DATE ||
    typeof bulkEditValue.value !== 'string' ||
    !DATE_ONLY_VALUE_REGEXP.test(bulkEditValue.value)
  ) {
    return {
      value: bulkEditValue,
      change: null
    };
  }

  const existingDateTimeSuffix =
    existingValue?.type === DatabaseFieldType.DATE &&
    typeof existingValue.value === 'string'
      ? existingValue.value.match(DATE_TIME_SUFFIX_REGEXP)?.[1]
      : undefined;
  const nextValue = `${bulkEditValue.value}${existingDateTimeSuffix ?? ''}`;
  const value: DatabaseValue<DatabaseFieldType.DATE> = {
    type: DatabaseFieldType.DATE,
    value: nextValue
  };

  return {
    value,
    change: {
      type: DatabaseFieldType.DATE,
      value: nextValue
    }
  };
}
